import { NgModule } from "@angular/core";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
// libs
import { TranslateModule } from "@ngx-translate/core";
import { NgxSpinnerModule } from "ngx-spinner";
import { UISharedModule } from "@mypxplat/xplat/features";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FileUploadModule } from "ng2-file-upload";
import { RoundProgressModule } from "angular-svg-round-progressbar";
import { ImageCropperModule } from "ngx-img-cropper";
import { RecaptchaModule } from "ng-recaptcha";
import { CookieService } from "ngx-cookie-service";
import { AngularDraggableModule } from "angular2-draggable";
import { ClipboardModule } from "ngx-clipboard";
import { UI_COMPONENTS } from "./components";
import { MODALS_COMPONENTS } from "./components";
import { UI_DIRECTIVES } from "./directives";
import { environment } from "@mypxplat/xplat/core";
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFirestoreModule } from "@angular/fire/compat/firestore";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { AngularFireMessagingModule } from "@angular/fire/compat/messaging";
import { YouTubePlayerModule } from "@angular/youtube-player";
import { DragulaModule } from "ng2-dragula";
import { FontAwesomeModule, FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { MaskitoDirective } from "@maskito/angular";
import { QuillModule } from "ngx-quill";
import { QuillConfigModule } from "ngx-quill/config";
import { A11yModule } from "@angular/cdk/a11y";
import { OverlayModule } from "@angular/cdk/overlay";
import { FuiCalendarComponent } from "./components/fui-calendar/fui-calendar.component";
import { faBookmark as farBookmark, faComment as farComment, faFlag as farFlag, faFaceSmile, faStar as farStar, faThumbsUp as farThumbsUp } from "@fortawesome/free-regular-svg-icons";
import {
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faChevronUp,
  faSpinner,
  faPlusSquare,
  faCheck,
  faArrowUpFromBracket,
  faTimes,
  faPhotoVideo,
  faSync,
  faUserCheck,
  faGlobe,
  faDownload,
  faExclamationCircle,
  faArrowLeft,
  faArrowRight,
  faCamera,
  faUser,
  faSearch,
  faCloudDownloadAlt,
  faEdit,
  faPaperclip,
  faPaperPlane,
  faFileAudio,
  faFileArchive,
  faLanguage,
  faStop,
  faCompass,
  faMinus,
  faStar,
  faScrewdriverWrench,
  faCheckCircle,
  faTimesCircle,
  faPencilAlt,
  faFolderOpen,
  faFile,
  faBars,
  faList,
  faTv,
  faWandMagicSparkles,
  faHome,
  faExternalLinkAlt,
  faCaretDown,
  faAppleAlt,
  faKey,
  faWrench,
  faUsers,
  faExclamationTriangle,
  faCog,
  faShoppingCart,
  faCloud,
  faQuestion,
  faFilter,
  faBook,
  faExpand,
  faPlay,
  faPlayCircle,
  faStopCircle,
  faExternalLinkSquareAlt,
  faInfoCircle,
  faPause,
  faLink,
  faThumbsUp,
  faInfo,
  faVideo,
  faFolder,
  faClock,
  faArrowAltCircleUp,
  faPlus,
  faImage,
  faFileImage,
  faComment,
  faComments,
  faTrash,
  faReply,
  faTrashAlt,
  faPlusCircle,
  faEllipsisH,
  faEnvelope,
  faBullhorn,
  faGuitar,
  faMicrophone,
  faBell,
  faThumbtack,
  faBookmark,
  faTableColumns,
  faCartShopping,
  faCompress,
  faHashtag,
  faVideoSlash,
  faGraduationCap,
  faCalendar,
  faTableCellsLarge,
  faArrowAltCircleDown,
  faMusic,
  faSun,
  faVolumeMute,
  faVolumeUp,
  faMoon,
  faStickyNote,
  faNewspaper,
  faCircle,
  faCheckSquare,
  faEye,
  faEyeSlash,
  faArrowUpRightFromSquare,
  faTh,
  faListUl,
  faArrowUp,
  faArrowDown,
  faLock,
  faCopy,
  faExternalLink,
  faTicket,
  faHeart,
  faBug,
  faQuestionCircle,
  faLayerGroup,
  faRightFromBracket,
  faArrowRotateLeft,
  faEgg,
  faArrowsRotate,
  faBan,
  faGift,
  faDollar,
  faMaximize,
  faMinimize,
  faEllipsisVertical,
  faCrown,
  faClone,
  faUserMinus,
  faUserPlus,
  faUserShield,
  faFlag,
  faLockOpen,
  faThumbtackSlash,
} from "@fortawesome/free-solid-svg-icons";
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";

import { faWindows, faApple, faLinux } from "@fortawesome/free-brands-svg-icons";
const MODULES = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  UISharedModule,
  NgxSpinnerModule,
  NgbModule,
  AngularDraggableModule,
  FileUploadModule,
  RoundProgressModule,
  RecaptchaModule,
  FontAwesomeModule,
  ImageCropperModule,
  AngularFirestoreModule,
  AngularFireAuthModule,
  AngularFireMessagingModule,
  ClipboardModule,
  YouTubePlayerModule,
  A11yModule,
  OverlayModule,
];

@NgModule({
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    ...MODULES,
    DragulaModule.forRoot(),
    MaskitoDirective,
    RecaptchaV3Module,
    QuillModule.forRoot(),
    QuillConfigModule.forRoot({
      modules: {
        toolbar: [["bold", "italic", "underline", "strike"]],
      },
    }),
    // Standalone lazy shell: FullCalendar loads on first use, not with this module.
    FuiCalendarComponent,
  ],
  declarations: [...UI_COMPONENTS, ...UI_DIRECTIVES],
  providers: [CookieService, CurrencyPipe, { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.reCaptchaV3Key }],
  exports: [...MODULES, ...UI_COMPONENTS, ...UI_DIRECTIVES, MaskitoDirective],
})
export class UIModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faChevronRight,
      faChevronLeft,
      faChevronDown,
      faUserMinus,
      faChevronUp,
      faSpinner,
      faPlusSquare,
      faPlus,
      faCheck,
      faArrowUpFromBracket,
      faTimes,
      faSync,
      faDownload,
      faCloudDownloadAlt,
      faExclamationCircle,
      faArrowLeft,
      faArrowRight,
      faCamera,
      faUser,
      faScrewdriverWrench,
      faEdit,
      faTableCellsLarge,
      faGlobe,
      faUserCheck,
      faPaperclip,
      faPaperPlane,
      faVideoSlash,
      faFileAudio,
      faHeart,
      faFileArchive,
      faStop,
      faTableColumns,
      faCartShopping,
      faLanguage,
      faMinus,
      faMaximize,
      faMinimize,
      faStar,
      faBell,
      faCheckCircle,
      faTimesCircle,
      faPencilAlt,
      faFolderOpen,
      faFile,
      faClone,
      faNewspaper,
      faBars,
      faList,
      faTv,
      faExternalLinkAlt,
      faCaretDown,
      faAppleAlt,
      faKey,
      faHashtag,
      faComment,
      faComments,
      faBullhorn,
      faVolumeMute,
      faVolumeUp,
      faCompress,
      faFilter,
      faExpand,
      faGuitar,
      faMicrophone,
      faWrench,
      faMusic,
      faWandMagicSparkles,
      faUsers,
      faExclamationTriangle,
      faCog,
      faShoppingCart,
      faCloud,
      faQuestion,
      faBook,
      faExpand,
      faPlay,
      faPlayCircle,
      faLayerGroup,
      faHome,
      faArrowAltCircleDown,
      faStopCircle,
      faPause,
      faExternalLinkSquareAlt,
      faInfoCircle,
      faLink,
      faThumbsUp,
      // The only REGULAR-style icon in the app: the outline smiley on the add-a-reaction
      // control. Solid `face-smile` is a filled disc, which reads as a reaction rather than a
      // button. Referenced as `["far", "face-smile"]` since the default prefix is `fas`.
      faFaceSmile,
      // Outline star for a channel that isn't a favorite yet (Communities hub rail),
      // `["far", "star"]`; the solid `faStar` is the favorited state.
      farStar,
      // Outline bookmark: a reply that won't save the post (comment reply toolbar).
      farBookmark,
      // The Featured rail's Like / Comment (DENG-1294): outline when off, solid `faThumbsUp` when liked.
      farThumbsUp,
      farComment,
      faCompass,
      faThumbtack,
      faBookmark,
      faTableColumns,
      faCartShopping,
      faClone,
      faVideo,
      faInfo,
      faFolder,
      faClock,
      faLock,
      faArrowAltCircleUp,
      faPhotoVideo,
      faImage,
      faFileImage,
      faTrash,
      faReply,
      faTrashAlt,
      faPlusCircle,
      faEllipsisH,
      faEnvelope,
      faGraduationCap,
      faCalendar,
      faSearch,
      faSun,
      faMoon,
      faStickyNote,
      faCircle,
      faCheckSquare,
      faEye,
      faEyeSlash,
      faArrowUpRightFromSquare,
      faTh,
      faListUl,
      faArrowUp,
      faArrowDown,
      faCopy,
      faExternalLink,
      faLock,
      faTicket,
      faBug,
      faQuestionCircle,
      faRightFromBracket,
      faArrowRotateLeft,
      faEgg,
      faUserMinus,
      faArrowsRotate,
      faRightFromBracket,
      faBan,
      faApple,
      faWindows,
      faLinux,
      faGift,
      faDollar,
      faEllipsisVertical,
      faCrown,
      // Post ••• menu icons (ActionItem.icon): Connect, Moderate Posts by, Flag / Unflag,
      // Unmark Pro+ Only, Remove from Featured.
      faUserPlus,
      faUserShield,
      faFlag,
      farFlag,
      faLockOpen,
      faThumbtackSlash
    );
  }
  audio;
}
